export default "__VITE_ASSET__DKezDkfL__"